module.exports = __webpack_public_path__ + "img/screen_6.4b91252c.svg";